var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectAccountDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=Account details, Property 2=ON"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000009255"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 41274",
    x: 4,
    y: 3,
    width: 16,
    height: 18,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000009254"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.5555 13.8V12.9C15.5555 12.4226 15.3558 11.9647 15.0001 11.6272C14.6445 11.2896 14.1622 11.1 13.6593 11.1H10.3407C9.83782 11.1 9.35549 11.2896 8.99987 11.6272C8.64425 11.9647 8.44446 12.4226 8.44446 12.9V13.8",
    stroke: "#68A14B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12 11.1C13.2273 11.1 14.2223 10.0926 14.2223 8.84998C14.2223 7.60733 13.2273 6.59998 12 6.59998C10.7728 6.59998 9.77783 7.60733 9.77783 8.84998C9.77783 10.0926 10.7728 11.1 12 11.1Z",
    stroke: "#68A14B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234251059",
    d: "M9.33337 16.5H14.4553",
    stroke: "#68A14B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectAccountDetails);
export default __webpack_public_path__ + "static/media/select-account-details.ac10cd72cc3ee0b0713895beca49a2b3.svg";
export { ForwardRef as ReactComponent };